import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; ran.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const r = await api.post("/auth/emergent-session", { session_id: sid });
        setUser(r.data.user);
        nav("/dashboard", { replace: true });
      } catch (e) {
        console.error("Emergent auth failed:", e); nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return <div className="flex items-center justify-center min-h-[50vh] text-slate-500" data-testid="auth-callback">Signing you in…</div>;
}
